module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/BKYS01_banner.5290efe5.png";